import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import * as pell from './pell';


@Component({
  selector: 'pell-editor',
  template: `<div #pell>
  <div [class]="actionBarClass">
    <button *ngFor="let action of actions" [class]="actionButtonClass" [title]="action.title" 
    (click)="action.result()" [innerHTML]="action.icon">
    </button>
  </div>
  <div contenteditable="true" [class]="contentClass" (input)="onInput($event)"></div>
</div>
`,
  styles: [`.pell{border-radius:5px;-webkit-box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1)}.pell,.pell-content{-webkit-box-sizing:border-box;box-sizing:border-box;width:100%}.pell-content{height:300px;outline:0;overflow-y:auto;padding:10px}.pell-actionbar{background-color:#fff;border-bottom:1px solid hsla(0,0%,4%,.1);border-top-left-radius:5px;border-top-right-radius:5px;width:100%}.pell-button{background-color:transparent;border:none;cursor:pointer;height:30px;outline:0;width:30px}`],
})
export class PellComponent implements OnInit {
  actions = Object.keys(pell.actions).map(action => pell.actions[action]);
  actionBarClass = 'pell-actionbar';
  actionButtonClass = 'pell-button';
  contentClass = 'pell-content';

  @Output()
  onChange = new EventEmitter<string>()
  constructor() { }

  ngOnInit() {
  }

  onInput(event: any) {
    this.onChange.emit(event.target.innerHTML);
  }
}
